import { queryForms } from '@wix/ambassador-forms-v4-form/http';
import _ from 'lodash';
import { extractImagesFromForms } from './utils';
const PAGE_LIMIT = 100;
const FILTER_SIZE = 100;
export const fetchOnlineProgramsQuizzes = async (httpClient, errorHandler, steps) => {
  const allQuizzes = [];
  const quizzesIds = steps.filter(step => {
    var _step$quizOptions;
    return (_step$quizOptions = step.quizOptions) == null ? void 0 : _step$quizOptions.id;
  }).map(step => {
    var _step$quizOptions2;
    return (_step$quizOptions2 = step.quizOptions) == null ? void 0 : _step$quizOptions2.id;
  });
  const quizzesIdsBatches = _.chunk(quizzesIds, FILTER_SIZE);
  const promiseArray = quizzesIdsBatches.map(batch => fetchQuizzesByID(batch, httpClient, errorHandler));
  const results = await Promise.allSettled(promiseArray);
  results.forEach(result => {
    if (result.status === 'fulfilled') {
      allQuizzes.push(...result.value);
    }
  });
  return extractImagesFromForms(allQuizzes);
};
const fetchQuizzesByID = async (quizzesIds, httpClient, errorHandler) => {
  const {
    withErrorHandler
  } = errorHandler;
  const quizzes = [];
  let cursor;
  let hasMore = false;
  await withErrorHandler(async () => {
    do {
      var _metadata$cursors;
      const {
        data
      } = await httpClient.request(queryForms({
        namespace: 'wix.achievements.quizzes.v1.quiz',
        query: {
          cursorPaging: {
            cursor,
            limit: PAGE_LIMIT
          },
          filter: {
            id: {
              $in: quizzesIds
            }
          }
        }
      }));
      const forms = data.forms;
      const metadata = data.metadata;
      quizzes.push(...(forms ?? []));
      hasMore = (metadata == null ? void 0 : metadata.hasNext) ?? false;
      cursor = metadata == null || (_metadata$cursors = metadata.cursors) == null ? void 0 : _metadata$cursors.next;
    } while (hasMore);
    return quizzes;
  }, {
    errorCodesMap: {}
  });
  return quizzes;
};
//# sourceMappingURL=fetch-online-programs-quiz-steps.js.map